<h3>Data:</h3>

<pre>{{ httpData$ | async | json }}</pre>

<h3>Posts:</h3>

<pre>{{ httpPosts$ | async | json }}</pre>
